module.exports = __webpack_public_path__ + "static/media/twitter.a91a9eaa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/twitter.svg
// module id = 2502
// module chunks = 0